module.exports = __webpack_public_path__ + "img/discount-small.344cad38.svg";